import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Box, Grid } from '@mui/material';
import CustomTable from '../../../../../components/table/SimpleTable';
import CustomeTableClassFees from '../../../../../components/table/SimpleTableClassFees';
import { ShowLoader } from '../../../../../redux/actions/loader'

const Showattendance = (props) => {
  const [data, setData] = useState([]);
  const [classData, setClassData] = useState([]);
  const [classDataOther, setClassDataOther] = useState([]);
  const [removedStudents, setRemovedStudents] = useState([]);
  const [totalDefaultsValue, setTotalDefaultsValue] = useState();
  const [updatevalue, setUpdatevalue] = useState()
  const url = useSelector((state) => state.Api);
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const dispatch = useDispatch()

  useEffect(() => {
    try {
      dispatch(ShowLoader('1'))
      axios.get(url?.Studentcurrentdayreport, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            //console.log(res.data.result);
            setData(res.data.result);
            dispatch(ShowLoader('0'))
          }
        })
        .catch((err) => {
          dispatch(ShowLoader('0'))
          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      dispatch(ShowLoader('0'))
      //console.error(err);
    }
  }, [updatevalue]);

  const update = async (event) => {
    await props.func(event)
    await setUpdatevalue(event)
  }
   
  const myfunc = async (param) => {
    props.func(param)
  }
  return (
    <>
      <Grid container mb={3}>
        {data.map((item, index) => (
          <Grid item key={index} lg={2} >
            <Box>
              {/* {item.ClassName} */}
              {
                // item.Status == 'empty' ?                   

                <Box >

                  <nav className='navigationClass'>
                    <ul>
                      <li className={item.Srn == props.highlightClass ? 'selectedClass' : 'noDropDown'} id={item.Srn} onClick={() => myfunc(item.Srn)}>
                        <span>{item?.ClassName_P}</span> <br />
                        <span>{item?.TeacherName}</span>
                      </li>
                    </ul>
                  </nav>
                  {/* <CustomBtn
                      click={() => myfunc(item.Srn)}
                      data="Show Table"
                    /> */}
                </Box>
                //       :
                // <Updatestatus func={update} data={item.Srn} classes={item.ClassName} />

              }
            </Box>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2}>
        {classData && classData.length > 0 ? (
          <>
            {/* Left Column */}
            <Grid item lg={6} md={6} sm={12}>
              <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
                <tbody>
                  <tr>
                    <td>{classData.length }</td> 
                    <td>ټوټل پوروړی ښاګردان</td>
                  </tr>
                  <tr>
                    <td>{totalDefaultsValue}</td> 
                    <td>ټوټل باندی پور</td>
                  </tr>
                </tbody>
              </table>

              <div >
                <CustomeTableClassFees data={classData} defaulters={'yes'} />
              </div>
            </Grid>

          </>
        ) : null}
        {classDataOther && classDataOther.length > 0 ? (
          <>

            {/* Right Column */}
            <Grid item lg={6} md={6} sm={12}>
              <table style={{ float:'right',  textAlign: 'left', borderCollapse: 'collapse' }}>
                <tbody>
                  <tr> 
                    <td>{classDataOther.length}</td>
                    <td>ټوټل بی پوره</td>
                  </tr> 
                  
                  <tr>
                    <td>{classDataOther?.reduce((total, item) => total + item.Dues, 0)}</td> 
                    <td>ټوټل اظافه</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ marginTop: '16px' }}>
                <CustomeTableClassFees data={classDataOther.sort((a, b) => a.Dues - b.Dues)} defaulters={'no'} />
              </div>
            </Grid>
          </>
        ) : null}


        {removedStudents && removedStudents.length > 0 ? (
          <>

            {/* Right Column */}
            <Grid item lg={6} md={6} sm={12}>
              <table style={{  float:'right',  textAlign: 'right', borderCollapse: 'collapse' }}>
                <tbody>
                  <tr>
                    <td>{removedStudents.length}</td> 
                    <td>ټوټل ایستل سوی ښاګردان</td>
                  </tr>
                  
                  <tr>
                    <td>{removedStudents?.reduce((total, item) => total + item.Dues, 0)}</td> 
                    <td>ټوټل باندی پور</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ marginTop: '16px' }}>
                <CustomeTableClassFees data={removedStudents.sort((a, b) => a.Dues - b.Dues)} defaulters={'removed'} />
              </div>
            </Grid>
          </>
        ) : null}
      </Grid>

    </>
  );
};

Showattendance.propTypes = {};

export default Showattendance;
